import http from '../../../../../common/utils/http'
import { API_BASE_URL } from '../../../../../common/utils/commonUrl'
import * as RoutePathConstants from '../../../../../constants/RoutePathConstants'
import moment from 'moment'

export default {
  data () {
    return {
      carNumber: '',
      data: [],
      pageNum: 1,
      pageSize: 50,
      dialogVisible: false,
      ruleForm: {
        finishTime: moment().format(),
        remark: '',
        maintenanceItemIdList: []
      },
      maintainTimeStatus: '1',
      memberServiceTeamList: [],
      memberServiceAdvisorList: [],
      membeMajorList: [],
      csmRemanufacturingAppointmentKanbanItemNameList: [],
      memberMaintenanceItemList: [],
      overhaulStatusList: [],
      memberMaintenanceItemList2: [],
      dataLength: ''
    }
  },
  watch: {
    'maintainTimeStatus' () {
      this.getOverhaulPageList()
    }
  },
  methods: {
    edit (item) {
      this.$router.push({
        path: RoutePathConstants.COMPLETION_MODIFICATION,
        query: {
          id: item.id
        }
      })
    },
    dateFormat (time) {
      return time ? moment(time).format('MM/DD HH:mm') : ''
    },
    pageSizeChange () {
      this.pageSize += 50
      this.getOverhaulPageList()
    },
    // 获取数据
    async getOverhaulPageList () {
      let res = await http.get(API_BASE_URL + `/api/wxoa/member/memberBasis/getOverhaulPageList?pageSort=id&pageOrder=desc&overhaulStatus=2000&pageNum=${this.pageNum}&pageSize=${this.pageSize}&maintainTimeStatus=${this.maintainTimeStatus}&carNumber=${this.carNumber}`)
      this.dataLength = res.data.data.totalRecord
      res.data.data.dataList.forEach(item => {
        this.memberServiceTeamList.forEach(it => {
          if (item.serviceTeam == it.dictCode) {
            item.serviceTeamName = it.label
          }
        })
      })
      res.data.data.dataList.forEach(item => {
        this.memberServiceAdvisorList.forEach(it => {
          if (item.serviceAdvisor == it.dictCode) {
            item.serviceAdvisorName = it.label
          }
        })
      })
      res.data.data.dataList.forEach(item => {
        this.membeMajorList.forEach(it => {
          if (item.major == it.dictCode) {
            item.majorName = it.label
          }
        })
      })
      res.data.data.dataList.forEach(item => {
        this.csmRemanufacturingAppointmentKanbanItemNameList.forEach(it => {
          if (item.maintenanceCategory == it.dictCode) {
            item.maintenanceCategoryName = it.label
          }
        })
      })
      res.data.data.dataList.forEach(item => {
        this.overhaulStatusList.forEach(it => {
          if (item.overhaulStatus == it.dictCode) {
            item.overhaulStatusName = it.label
          }
        })
      })
      res.data.data.dataList.forEach(item => {
        item.toShopTime = this.dateFormat(item.toShopTime)
      })
      this.data = res.data.data.dataList
    },
    getOverhaulDetail (id) {
      return http.get(API_BASE_URL + '/api/wxoa/member/memberBasis/getOverhaulAfterMaintenanceDetail?id=' + id)
    },
    async maintenanceItems (item) {
      this.dialogVisible = true
      let res = await this.getOverhaulDetail(item.id)
      this.ruleForm = {
        carNumber: item.carNumber,
        toShopTime: res.data.data.toShopTime,
        finishTime: res.data.data.finishTime,
        remark: res.data.data.remark,
        maintenanceItemIdList: res.data.data.maintenanceItemIdList
      }
      this.memberMaintenanceItemList2 = []
      this.memberMaintenanceItemList.forEach(item => {
        res.data.data.maintenanceItemIdList.forEach(it => {
          if (item.value == it) {
            this.memberMaintenanceItemList2.push(item)
          }
        })
      })
    },
    async getDictCode () {
      // 服务班组
      let memberServiceTeamList = await http.get(API_BASE_URL + '/api/dict/typeCode/memberServiceTeam')
      this.memberServiceTeamList = memberServiceTeamList.data.data
      // 服务顾问
      let memberServiceAdvisorList = await http.get(API_BASE_URL + '/api/dict/typeCode/memberServiceAdvisor')
      this.memberServiceAdvisorList = memberServiceAdvisorList.data.data
      // 主修人
      let membeMajorList = await http.get(API_BASE_URL + '/api/dict/typeCode/membeMajor')
      this.membeMajorList = membeMajorList.data.data
      // 维修类别
      let csmRemanufacturingAppointmentKanbanItemNameList = await http.get(API_BASE_URL + '/api/dict/typeCode/memberMaintenanceCategory')
      this.csmRemanufacturingAppointmentKanbanItemNameList = csmRemanufacturingAppointmentKanbanItemNameList.data.data
      // 预检项目
      let memberMaintenanceItemList = await http.get(API_BASE_URL + '/api/dict/typeCode/memberMaintenanceItem')
      this.memberMaintenanceItemList = memberMaintenanceItemList.data.data
      let overhaulStatusList = await http.get(API_BASE_URL + '/api/dict/typeCode/memberOverhaulStatus')
      this.overhaulStatusList = overhaulStatusList.data.data
    }
  },
  async mounted () {
    await this.getDictCode()
    await this.getOverhaulPageList()
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/member/views/completionRecord/completionRecord.js